/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogSessionInit
 */
export interface LogSessionInit {
    /**
     * 
     * @type {string}
     * @memberof LogSessionInit
     */
    back?: string;
    /**
     * 
     * @type {string}
     * @memberof LogSessionInit
     */
    tail?: string;
}

/**
 * Check if a given object implements the LogSessionInit interface.
 */
export function instanceOfLogSessionInit(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LogSessionInitFromJSON(json: any): LogSessionInit {
    return LogSessionInitFromJSONTyped(json, false);
}

export function LogSessionInitFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogSessionInit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'back': !exists(json, 'back') ? undefined : json['back'],
        'tail': !exists(json, 'tail') ? undefined : json['tail'],
    };
}

export function LogSessionInitToJSON(value?: LogSessionInit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'back': value.back,
        'tail': value.tail,
    };
}

